import DescriptionIcon from "@mui/icons-material/Description";
import SlideshowIcon from "@mui/icons-material/Slideshow";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import PlayCircleFilledIcon from "@mui/icons-material/PlayCircleFilled";
import { TrainingSectionTypeKey } from "./enums";

// Icon based on section type
export const getIconByType = (type, small = true) => {
  const commonStyles = {
    fontSize: small ? "20px" : "30px",
    borderRadius: "10px",
    color: "white",
    p: "10px",
    boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
  };

  switch (type) {
    case TrainingSectionTypeKey.VIDEO:
      return (
        <PlayCircleFilledIcon
          sx={{
            ...commonStyles,
            background: "linear-gradient(to bottom right, #4ade80, #16a34a)",
          }}
        />
      );
    case TrainingSectionTypeKey.DOCX:
      return (
        <DescriptionIcon
          sx={{
            ...commonStyles,
            background: "linear-gradient(to bottom right, #3b82f6, #2563eb)",
          }}
        />
      );
    case TrainingSectionTypeKey.PPTX:
      return (
        <SlideshowIcon
          sx={{
            ...commonStyles,
            background: "linear-gradient(to bottom right, #f59e0b, #d97706)",
          }}
        />
      );
    case TrainingSectionTypeKey.PDF:
      return (
        <PictureAsPdfIcon
          sx={{
            ...commonStyles,
            background: "linear-gradient(to bottom right, #ef4444, #dc2626)",
          }}
        />
      );
    default:
      return (
        <DescriptionIcon
          sx={{
            ...commonStyles,
            background: "linear-gradient(to bottom right, #6b7280, #4b5563)",
          }}
        />
      );
  }
};
